export default __webpack_public_path__ + "static/media/Social Logical Learner.b1099604.png";